import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {DataTableRequest} from "../types/Requests/API/DataTableRequest";

type DataTableStorageState = Record<string, DataTableRequest>;

interface UpdateDataTablePayload {
    path: string;
    request: DataTableRequest;
}

const STORAGE_KEY = 'dataTableSearch';

const loadStoredState = (): DataTableStorageState => {
    if (typeof localStorage === 'undefined') {
        return {};
    }

    try {
        const storedState = localStorage.getItem(STORAGE_KEY);
        return storedState ? JSON.parse(storedState) as DataTableStorageState : {};
    } catch {
        return {};
    }
};

const persistState = (state: DataTableStorageState) => {
    if (typeof localStorage === 'undefined') {
        return;
    }

    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch {
        // Ignore write errors (e.g., storage full or disabled)
    }
};

const initialState: DataTableStorageState = loadStoredState();

const dataTableSearchSlice = createSlice({
    name: 'dataTableSearch',
    initialState,
    reducers: {
        setDataTableRequest: (state, action: PayloadAction<UpdateDataTablePayload>) => {
            state[action.payload.path] = {...action.payload.request};
            persistState(state);
        },
        removeDataTableRequest: (state, action: PayloadAction<string>) => {
            if (state[action.payload]) {
                delete state[action.payload];
                persistState(state);
            }
        }
    }
});

export const {setDataTableRequest, removeDataTableRequest} = dataTableSearchSlice.actions;
export default dataTableSearchSlice.reducer;
